import { ACCENT, ICON_SIZE } from './constants';

export const IconTrending = ({
  size = ICON_SIZE,
  color = ACCENT,
}: Landing.IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <polyline
      points="23 6 13.5 15.5 8.5 10.5 1 18"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="17 6 23 6 23 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
